var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "employees-card-bottom" },
        [
          _c("formBox", {
            attrs: { total: _vm.total },
            on: { confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt10",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, height: _vm.tableHeight },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "card.name", label: "姓名" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "frame.name",
                  label: "部门",
                  "min-width": "140px",
                },
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "班次信息" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "group", label: "考勤组名称", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.group || "--") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "created_at", label: "日期", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm
                                    .$moment(row.created_at)
                                    .format("YYYY-MM-DD")
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "考勤班次",
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("div", [
                              _vm._v(_vm._s(row.shift_data.name || "--")),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.getShift(row.shift_data))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "上班1" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "province", label: "最早打卡", width: "95" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.handle(
                                    row.one_shift_status,
                                    row.one_shift_is_after,
                                    row.one_shift_time
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "city", label: "打卡结果", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openFn(
                                      row.one_shift_status,
                                      row.one_shift_location_status,
                                      1,
                                      row.id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.one_shift_status > 1 ||
                                      row.one_shift_location_status > 1
                                        ? "red"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getStatus(
                                            row.one_shift_status,
                                            row.one_shift_location_status,
                                            row.one_shift_normal
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "下班1" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "province", label: "最晚打卡", width: "95" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.handle(
                                    row.two_shift_status,
                                    row.two_shift_is_after,
                                    row.two_shift_time
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "city", label: "打卡结果", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openFn(
                                      row.two_shift_status,
                                      row.two_shift_location_status,
                                      2,
                                      row.id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.two_shift_status > 1 ||
                                      row.two_shift_location_status > 0
                                        ? "red"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getStatus(
                                            row.two_shift_status,
                                            row.two_shift_location_status,
                                            row.two_shift_normal
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "上班2" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "province", label: "最早打卡", width: "95" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.handle(
                                    row.three_shift_status,
                                    row.three_shift_is_after,
                                    row.three_shift_time
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "city", label: "打卡结果", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openFn(
                                      row.three_shift_status,
                                      row.three_shift_location_status,
                                      3,
                                      row.id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.three_shift_status > 1 ||
                                      row.three_shift_location_status > 0
                                        ? "red"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getStatus(
                                            row.three_shift_status,
                                            row.three_shift_location_status,
                                            row.three_shift_normal
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "下班2" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "province", label: "最晚打卡", width: "95" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.handle(
                                    row.four_shift_status,
                                    row.four_shift_is_after,
                                    row.four_shift_time
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "city", label: "打卡结果", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openFn(
                                      row.four_shift_status,
                                      row.four_shift_location_status,
                                      4,
                                      row.id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.four_shift_status > 1 ||
                                      row.four_shift_location_status > 0
                                        ? "red"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getStatus(
                                            row.four_shift_status,
                                            row.four_shift_location_status,
                                            row.four_shift_normal
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "时长统计（小时）" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "required_work_hours",
                      label: "应出勤",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actual_work_hours",
                      label: "实际出勤",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "overtime_work_hours",
                      label: "加班时长",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "leave_time",
                      label: "请假时长",
                      width: "120",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openRecord(row)
                              },
                            },
                          },
                          [_vm._v("处理记录")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-fixed" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.where.limit,
                  "current-page": _vm.where.page,
                  "page-sizes": [15, 20, 30],
                  layout: "total,sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("record-drawer", { ref: "recordDrawer" }),
      _vm._v(" "),
      _c(
        "oa-dialog",
        {
          ref: "oaDialog",
          attrs: { fromData: _vm.fromData },
          on: { submit: _vm.submit },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.form.name, "label-width": "60px" } },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            placeholder: "请选择",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.dis_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dis_status", $$v)
                            },
                            expression: "form.dis_status",
                          },
                        },
                        _vm._l(_vm.salesmanList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "el-icon-d-arrow-right" }),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: { size: "small", placeholder: "请选择" },
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        _vm._l(_vm.salesmanList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.form.dis_locationStatus !== 0
                ? _c("el-form-item", { attrs: { "label-width": "60px" } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: "请选择",
                              disabled: "",
                            },
                            model: {
                              value: _vm.form.dis_locationStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "dis_locationStatus", $$v)
                              },
                              expression: "form.dis_locationStatus",
                            },
                          },
                          _vm._l(_vm.placeList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "el-icon-d-arrow-right" }),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            attrs: { size: "small", placeholder: "请选择" },
                            model: {
                              value: _vm.form.location_status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "location_status", $$v)
                              },
                              expression: "form.location_status",
                            },
                          },
                          _vm._l(_vm.placeList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", "label-width": "60px" } },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", placeholder: "请输入内容" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          template: true,
          "save-name": _vm.saveName,
          "export-data": _vm.exportData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }